import classNames from "classnames";

import { Star } from "./star/star.component";

import "./rating.scss";

export type RatingProps = {
    max?: number;
    value: number;
    size?: number;
    className?: string;
};

const Rating = ({ className, max = 5, value, size = 32 }: RatingProps) => {
    const starValues = Array.from({ length: max }, (_, index) =>
        Math.min(Math.max(value - index, 0), 1)
    );

    return (
        <div className={classNames("d-flex rating", className)}>
            <span className="rating__stars">
                {starValues.map((starValue, index) => {
                    return (
                        <Star
                            value={starValue}
                            key={index}
                            size={size}
                        />
                    );
                })}
            </span>
        </div>
    );
};

export { Rating };
